const PayMethodIcon = ({
  color = "#2B363B",
  width = 18,
  height = 18,
  opacity = 0.75,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    opacity={opacity}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.5117 8.67833C15 8.19 15 7.405 15 5.83333C15 4.26167 15 3.47667 14.5117 2.98833M14.5117 8.67833C14.0233 9.16667 13.2383 9.16667 11.6667 9.16667H8.33333C6.76167 9.16667 5.97667 9.16667 5.48833 8.67833M14.5117 2.98833C14.0233 2.5 13.2383 2.5 11.6667 2.5H8.33333C6.76167 2.5 5.97667 2.5 5.48833 2.98833M5.48833 2.98833C5 3.47667 5 4.26167 5 5.83333C5 7.405 5 8.19 5.48833 8.67833M10.8333 5.83333C10.8333 6.05435 10.7455 6.26631 10.5893 6.42259C10.433 6.57887 10.221 6.66667 10 6.66667C9.77899 6.66667 9.56702 6.57887 9.41074 6.42259C9.25446 6.26631 9.16667 6.05435 9.16667 5.83333C9.16667 5.61232 9.25446 5.40036 9.41074 5.24408C9.56702 5.0878 9.77899 5 10 5C10.221 5 10.433 5.0878 10.5893 5.24408C10.7455 5.40036 10.8333 5.61232 10.8333 5.83333Z"
      stroke={color}
      strokeWidth="1.25"
    />
    <path
      d="M14.9998 5C14.3368 5 13.7009 4.73661 13.2321 4.26777C12.7632 3.79893 12.4998 3.16304 12.4998 2.5M14.9998 6.66667C14.3368 6.66667 13.7009 6.93006 13.2321 7.3989C12.7632 7.86774 12.4998 8.50363 12.4998 9.16667M4.99984 5C5.66288 5 6.29876 4.73661 6.7676 4.26777C7.23645 3.79893 7.49984 3.16304 7.49984 2.5M4.99984 6.66667C5.66288 6.66667 6.29876 6.93006 6.7676 7.3989C7.23645 7.86774 7.49984 8.50363 7.49984 9.16667M4.1665 16.99H6.04984C6.8915 16.99 7.744 17.0783 8.56317 17.2467C10.0258 17.5462 11.5304 17.5795 13.0048 17.345C13.7282 17.2283 14.4382 17.0492 15.0815 16.7392C15.6615 16.4583 16.3723 16.0642 16.8498 15.6217C17.3265 15.18 17.8232 14.4575 18.1748 13.8925C18.4782 13.4075 18.3315 12.8133 17.8532 12.4525C17.5842 12.2573 17.2605 12.1523 16.9282 12.1523C16.5959 12.1523 16.2721 12.2573 16.0032 12.4525L14.4973 13.59C13.914 14.0317 13.2765 14.4375 12.5173 14.5583C12.4257 14.5728 12.3298 14.5858 12.2298 14.5975M12.2298 14.5975L12.1382 14.6075M12.2298 14.5975C12.3632 14.5614 12.4855 14.4926 12.5857 14.3975C12.7114 14.289 12.8142 14.1564 12.8878 14.0074C12.9613 13.8585 13.0043 13.6963 13.0141 13.5305C13.0239 13.3647 13.0003 13.1986 12.9448 13.0421C12.8892 12.8855 12.8028 12.7417 12.6907 12.6192C12.5821 12.4986 12.4556 12.3955 12.3157 12.3133C9.98484 10.9225 6.35734 11.9817 4.1665 13.5358M12.2298 14.5975C12.1997 14.6042 12.169 14.6076 12.1382 14.6075M12.1382 14.6075C11.6356 14.6579 11.1293 14.659 10.6265 14.6108"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
    />
    <path
      d="M4.1665 12.9167C4.1665 12.2264 3.60686 11.6667 2.9165 11.6667C2.22615 11.6667 1.6665 12.2264 1.6665 12.9167V17.0834C1.6665 17.7738 2.22615 18.3334 2.9165 18.3334C3.60686 18.3334 4.1665 17.7738 4.1665 17.0834V12.9167Z"
      stroke={color}
      strokeWidth="1.25"
    />
  </svg>
);

export default PayMethodIcon;
